module.exports = __webpack_public_path__ + "static/media/card.a169b750.svg";